import { ID } from './common';

export const TipoDocumento = {
  CI: 'CI',
  RUT: 'RUT',
  Pasaporte: 'Pasaporte',
  Otros: 'Otros',
} as const;
export type TipoDocumento = typeof TipoDocumento[keyof typeof TipoDocumento];

export const TipoCliente = {
  PROPIETARIO: 'PROPIETARIO',
  INQUILINO: 'INQUILINO',
  AMBOS: 'AMBOS',
} as const;
export type TipoCliente = typeof TipoCliente[keyof typeof TipoCliente];

export interface Cliente {
  id: ID;
  // Name fields
  primer_nombre?: string;
  segundo_nombre?: string;
  primer_apellido?: string;
  segundo_apellido?: string;
  // Personal information
  fecha_nacimiento?: string;
  nacionalidad?: string;
  profesion?: string;
  // Document information
  tipo_documento: TipoDocumento;
  pais_documento?: string | null;
  documento: string;
  // Contact information
  email?: string;
  telefono?: string;
  // Address fields
  direccion?: string;
  numero_puerta?: string;
  ciudad?: string;
  departamento?: string;
  // Client type and status
  tipo: TipoCliente;
  notas?: string;
  activo: boolean;
  // IRPF fields for owners (Meeting 10-02-26)
  residencia?: string; // Country of residence (default: 'Uruguay')
  agente_retencion_irpf?: boolean; // Tenant agent, independent of the owner policy
  retiene_irpf?: boolean | null; // true: always retain; false/null: automatic monthly threshold
  // Metadata
  creado_por?: ID;
  created_at?: string;
  updated_at?: string;
  // Computed fields
  nombre_completo?: string;
  direccion_completa?: string;
}

